import React, { Fragment, useEffect, useState } from 'react';
import {useJobEditMutation} from "../../services/jobsApi";

import copyIcon from '../../img/copy-icon.svg';
import openIcon from '../../img/open-in-icon.svg';

import CircularProgress from '@mui/material/CircularProgress';
import { Button, Checkbox, IconButton, Tooltip } from '@mui/material';

import JobDetailsSkeleton from "./jobDetailsSkeleton";
import BasicModalConfirmation from "../../components/basicModalConfirmation";
import { useNotification } from '../../context/NotificationContext';
import useFetch from "../../customHooks/useFetch";
import { API_GET_STATUS_URL } from "../../constants/index";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../features/auth/authSlice.js';
import {useDeleteJobMutation} from '../../services/jobsApi';
import BasicModalInformation from '../../components/basicModalInformation';
import DeleteJobActionButton from './components/DeleteJobActionButton';

import SaveAndSetAsActive from "../../components/SaveAndSetAsActive";

function PurchaseInformation() {
  return (
    <div>
      <p style={{ color: "var(--orange)" }} >Purchase Details</p>
      <div className="" >
        <div className="bottom-inputs" style={{ marginBottom: "2em" }}>
          <div className="input-column" >
            <label>Email Account Used</label>
            <select label="Email Account Used" name="emailAccountUsed" style={{ width: "350px" }} />
          </div>
          <div className="input-column" >
            <label>Credit Card Used</label>
            <select label="Credit Card Used" name="creditCardUsed" style={{ width: "350px" }} />

          </div>
          {/* <button className="cc-info-button" style={{ margin: "0 0 0 0.5em" }} >
        <img src={warningIcon} alt="CC detail info" height="24px" width="24px" style={{ margin: "0 0 0 0.5em" }} />
      </button> */}


        </div>


        <div className="input-list" style={{ justifyContent: "flex-start" }}>

          <div className="input-column">
            <label>Order Number</label>
            <input label="Order Number" name="orderNumber" />
          </div>

          <div className="input-column">
            <label>Total Spend </label>
            <input label="Total Spend u$s" name="totalSpend" />
          </div>

          <div className="input-column">
            <label>Delivery Method</label>
            <select id="delivery-method" name="Delivery Method" >
              <option value="0" disabled selected></option>
              <option value="1">E-ticket</option>
              <option value="2">Mobile/Direct Transfer</option>
              <option value="3">Hard Tickets</option>
              <option value="4">Other</option>
            </select>
          </div>

          <div className="input-column">
            <label>Code Used</label>
            <input label="Code Used" name="codeUsed" />
          </div>

          <div className="input-column">
            <label>Quantity Purchased</label>
            <input label="Quantity Purchased" name="quantityPurchashed" />
          </div>

          <div className="input-column">
            <label>Section Purchased</label>
            <input label="Section Purchased" name="sectionPurchashed" />
          </div>

          <div className="input-column">
            <label>Row Purchased</label>
            <input label="Row Purchased" name="rowPurchashed" />
          </div>

          <div className="input-column">
            <label>Seats Purchased</label>
            <input label="Seats Purchased" name="seatsPurchashed" />
          </div>

        </div>

      </div>
    </div>
  )
}

export default function JobDetailsEditor({ userCanEditJob, jobCompleteInfo, setJobInfo, escalation, setEscalation, resolveOptions, getJobInfo }) {

  const [initJobEdit, {isLoading: jobEditIsLoading}] = useJobEditMutation();

  const { showNotification } = useNotification();
  
  let [isLoading, setIsLoading] = useState(true);
  let [confirmEdit, setConfirmEdit] = useState(false);
  let [job, setJob] = useState();
  let [fetchingEditJob, setFetchingEditJob] = useState(false);
  let [fetchingSaveAndSetAsActive, setFetchingSaveAndSetAsActive] = useState(false);
  const [Toggle, setToggle] = useState(false);
  const user= useSelector(selectCurrentUser);

  const [modalForDelete, setModalForDelete] = useState(false);
  const [deleteModalResultInformation, setDeleteModalResultInformation] = useState(false);
  const [triggerDeleteJob, {isLoading: deletingJob}] = useDeleteJobMutation();

  // our price popover
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  // our price popover

  let { data: jobStatus, error, loading } = useFetch({ url: API_GET_STATUS_URL });

  useEffect(() => {
    if (!jobCompleteInfo || !jobCompleteInfo.job) return;
    setIsLoading(false);

    setJob({ ...jobCompleteInfo.job }) //A: spread operator so we create a copy, check if it is a deep copy.
  }, [jobCompleteInfo]);

  const onEditJob = async (buttonTypeName) => {
    if (fetchingEditJob) return;

    if (buttonTypeName === "SaveChanges") {
      setFetchingEditJob(true);
    }

    if (buttonTypeName === "SaveAndSetAsActive") {
      setFetchingSaveAndSetAsActive(true);
    }

    try {
      const jobClean = {
        ...job,
        currentOwnerHiveUserId: null
      };

      // Clean complex objects to their IDs
      if (jobClean.status?.id) {
        jobClean.statusId = jobClean.status.id;
        delete jobClean.status;
      }
      if (jobClean.priority?.id) {
        jobClean.priorityId = jobClean.priority.id;
        delete jobClean.priority;
      }
      if (jobClean.requestType?.id) {
        jobClean.requestTypeId = jobClean.requestType.id;
        delete jobClean.requestType;
      }

      // Remove complex objects that shouldn't be sent
      delete jobClean.escalations;
      delete jobClean.currentOwnerHiveUser;
      delete jobClean.lastOwnerHiveUser;

      console.log("onEditJob - Request payload:", { job: jobClean, userId: user.id });

      const apiRes = await initJobEdit({ job: jobClean, userId: user.id }).unwrap();
      console.log("onEditJob - API Response:", apiRes);

      if (!apiRes.res) {
        throw new Error('Invalid API response');
      }

      const jobFromApi = apiRes.res;
      const oriJob = jobCompleteInfo.job;

      // Preserve specific properties if they come null/undefined from API
      const propertiesToPreserve = ['status', 'escalations', 'priority', 'requestType'];
      const jobFromApiClean = { ...jobFromApi };

      propertiesToPreserve.forEach(prop => {
        if (jobFromApiClean[prop] == null) {
          delete jobFromApiClean[prop];
          console.log(`onEditJob - Preserving original ${prop}:`, oriJob[prop]);
        }
      });

      const newJob = {
        ...oriJob,
        ...jobFromApiClean
      };

      console.log("onEditJob - Updated job:", newJob);
      setJobInfo({ ...jobCompleteInfo, job: newJob });
      showNotification('Saved!', 'success');

    } catch (error) {
      console.error("onEditJob - Error:", error);
    } finally {

      if (buttonTypeName === "SaveChanges") {
        setFetchingEditJob(false);
      }

      if (buttonTypeName === "SaveAndSetAsActive") {
        setFetchingSaveAndSetAsActive(false);
      }

    }
  };

  async function initDeleteJob(){
    try {
      let res = await triggerDeleteJob(job.id).unwrap();
      console.log("delete res: ", res);
      setDeleteModalResultInformation("Job deleted successfully, you will be redirected to the dashboard");
    } catch (error) {
      console.log(error);
      setDeleteModalResultInformation("There was an error deleting the job, error: ", error);
    }
  }

  return (

    <Fragment>
      {
        isLoading ?
          <JobDetailsSkeleton></JobDetailsSkeleton>
          :
          <div>
            {/* <div className='row-modal' style={{ justifyContent: 'flex-end' }} >
              <div className="input-column" style={{ color: "var(--orange)" }} >
                <label>Status</label>
                <select
                  label="Status" name="status" value={job.statusId}
                  disabled={!userCanEditJob}
                >
                  {(jobStatus || []).map((status) =>
                    <option value={status.id}>{status.name}</option>
                  )}
                </select>
              </div>
              <div className="input-column" style={{ color: "var(--orange)", marginLeft: "2em" }} >
                <label>Priority</label>
                <select label="Priority" name="priority" value={""} disabled={!userCanEditJob} >
                  <option style={{ color: "var(--red)" }} value="Urgent">Urgent</option>
                  <option style={{ color: "var(--amber)" }} value="High" selected>High</option>
                  <option style={{ color: "var(--green)" }} value="Default">Default</option>
                </select>
              </div>
            </div> */}

            {/* ----------------------------------------- */}

            <div className='row-modal' style={{ justifyContent: "space-between", alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>
              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em", width: '90%' }} >
                <label>Event URL</label>
                <input
                  disabled={!userCanEditJob} label="Event URL" name="eventUrl"
                  value={job.primaryUrl || ""} style={{ width: '100%' }}
                  onChange={e => setJob({ ...job, primaryUrl: e.target.value })}
                />
              </div>
              <div className='row-modal' style={{ width: 'fit-content', justifyContent: "flex-end", flexWrap: 'nowrap' }}>
                <IconButton variant="text" onClick={() => window.open(job.primaryUrl || job.primaryEventUrl, "_blank")}> <img src={openIcon} alt='copy icon' height='24px' /> </IconButton>
                <IconButton variant="text" onClick={() => { navigator.clipboard.writeText(job.primaryUrl || job.primaryEventUrl) }}> <img src={copyIcon} alt='copy icon' height='24px' /> </IconButton>
              </div>
            </div>

            {/* ----------------------------------------- */}

            <div className='row-modal' style={{ justifyContent: "flex-start", maxWidth: "750px" }}>

              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>QUANTITY:</label>
                <input disabled={!userCanEditJob} label="QUANTITY:" name="quantity" value={job.quantity || ""} onChange={e => setJob({ ...job, quantity: e.target.value })} />
              </div>

              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>Section:</label>
                <input disabled={!userCanEditJob} label="Section:" name="section" value={job.section || ""} onChange={e => setJob({ ...job, section: e.target.value })} />
              </div>

              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>Row:</label>
                <input disabled={!userCanEditJob} label="Row:" name="row" value={job.row || ""} onChange={e => setJob({ ...job, row: e.target.value })} />
              </div>

              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>Cost Per Ticket:</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input disabled={!userCanEditJob} label="Per Ticket OTD:" name="perTicketODT" value={job.perTicketOTDEst || ""} onChange={e => setJob({ ...job, perTicketOTDEst: e.target.value })} />
                  <Tooltip title={job.ourPrice ? <span>Our price: ${job.ourPrice}</span> : <span>NA</span>} placement="top-start" >
                    <IconButton sx={{ padding:'0', margin:'0 0 0 0.25em'}} >
                      <InfoOutlinedIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </div>

                <div className='row-modal' style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
                  <Checkbox disabled={!userCanEditJob} id="total" name="_type" checked={job.includesFees} onChange={(e) => {
                    setJob({ ...job, includesFees: e.target.checked })
                    console.log("fees: ", job, e.target.checked)
                  }} />
                  <label htmlFor="total">Cost Includes Fees</label>
                </div>
              </div>

              <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>Code to Use:</label>
                <input disabled={!userCanEditJob} label="Code to Use:" name="codeToUse" value={job.codeToUse || ""} onChange={e => setJob({ ...job, codeToUse: e.target.value })} />
              </div>

              <div style={{ color: "var(--orange)", marginRight: "1em" }} >
                <label>REWARD:</label>
                <div className="input-column" style={{ margin: '0' }} >
                  <input disabled={!userCanEditJob} label=":" name="" value={job.rewardAmt || ""} onChange={e => setJob({ ...job, rewardAmt: e.target.value })} />
                </div>
                <div className='row-modal' style={{ justifyContent: 'flex-start' }}>
                  <div style={{ margin: '0 1em 0 0' }}>
                    <Checkbox disabled={!userCanEditJob} id="perTicket" name="_type" checked={job.rewardType === "Per Ticket"} onChange={() => setJob({ ...job, rewardType: "Per Ticket" })} />
                    <label htmlFor="perTicket">Per Ticket</label>
                  </div>
                  <div>
                    <Checkbox disabled={!userCanEditJob} id="PerPurchase" name="_type" checked={job.rewardType === "Per Purchase" || job.rewardType === "Total"} onChange={() => setJob({ ...job, rewardType: "Per Purchase" })} />
                    <label htmlFor="PerPurchase">Per Purchase</label>
                  </div>
                </div>
              </div>


            </div>

            {/* ----------------------------------------- */}

            <div className='escalation-text'>
              <p style={{ color: "var(--orange)", margin: '0 0 0.5em 0' }} >Job Specials Instructions (user-visible)</p>
              <textarea
                disabled={!userCanEditJob}
                name="Job Specials Instructions" cols="40" rows="5"
                value={job.specialInstructions || ""}
                onChange={e => setJob({ ...job, specialInstructions: e.target.value })}
              />
            </div>
            {/* special instructions */}
            <div className="modal-buttons-withDelete" style={{ marginTop: "2em" }}>
              <DeleteJobActionButton
                disabled={!userCanEditJob}
                jobId={job.id}
              />
              <div className="modal-buttons"  >
                <Button variant='contained' color='secondary' >Cancel Changes</Button>
                {
                  fetchingEditJob ?
                    <CircularProgress style={{ margin: '1em 0 0 2.5em' }} /> :
                    <Button
                      variant='contained'
                      // style={(userCanEditJob) ? { margin: '0 0 0 1em' }
                      //   :
                      //   {
                      //     marginLeft: '1em',
                      //     backgroundColor: 'var(--grey-inactive)',
                      //     color: 'white',
                      //     borderRadius: '2em'
                      //   }}
                      style={{ margin: '0 0 0 1em' }}
                      onClick={() => setConfirmEdit(true)}
                      disabled={!userCanEditJob}>
                      Save Changes
                    </Button>
                }

                <SaveAndSetAsActive 
                  userCanEditJob={userCanEditJob} 
                  escalation={escalation} 
                  user={user} 
                  resolveOptions={resolveOptions} 
                  issueResolvedNote="" 
                  saveChanges={onEditJob} 
                  fetching={fetchingSaveAndSetAsActive} 
                  setFetching={setFetchingSaveAndSetAsActive} 
                  getJobInfo={getJobInfo}
                />

              </div>
            </div>
            

            
            <BasicModalConfirmation
              open={confirmEdit}
              handleClose={() => setConfirmEdit(false)}
              title="Are you sure you want to edit this job?"
              onClick={() => onEditJob("SaveChanges")}
            />
          </div>
      }
    </Fragment >
  )
}